export default __webpack_public_path__ + "static/media/group-option-skincolor-selected.8cf4f8b9.svg";